var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentProjection',{attrs:{"type":"event","headline":_vm.headline,"location":_vm.location,"date":_vm.formattedDateFromDateTo,"page-content":_vm.catalogPageContent,"overview-page-label":_vm.overviewPageLabel,"overview-page-link":_vm.overviewPageLink,"show-in-this-language":_vm.showInThisLanguage}})
}
var staticRenderFns = []

export { render, staticRenderFns }